import React from 'react';

import { Display } from 'craft/containers/Toolbox/sections/Layout/Display';
import { CssSelectorId } from 'craft/types/cssSelector';

export enum ToolboxTabs {
  Component = 'Component',
  Interactions = 'Interactions',
  Placements = 'Placements',
}

export enum ToolboxComponentSections {
  NameAndType = 'NameAndType',
  Generic = 'Generic',
  Layout = 'Layout',
  Size = 'Size',
  Spacing = 'Spacing',
  Background = 'Background',
  Border = 'Border',
  Shadow = 'Shadow',
}

export const defaultToolboxComponentSchema = {
  [ToolboxComponentSections.NameAndType]: {
    isVisible: true,
    variantSelector: undefined as React.FC<any> | undefined,
  },
  [ToolboxComponentSections.Generic]: {
    isVisible: true,
  },
  [ToolboxComponentSections.Layout]: {
    isVisible: true,
    blockedDisplays: [] as Display[],
    defaultDisplay: undefined as Display | undefined,
    cssSelectorId: undefined as CssSelectorId | undefined,
  },
  [ToolboxComponentSections.Size]: {
    isVisible: true,
    hasOverflow: false,
    hasObjectFit: false,
    hasMinMaxSize: true,
    hasPercentageSize: true,
    hasAutoSize: false,
    cssSelectorId: undefined as CssSelectorId | undefined,
  },
  [ToolboxComponentSections.Spacing]: {
    cssSelectorId: undefined as CssSelectorId | undefined,
    hasMargin: true,
    hasPadding: true,
  },
  [ToolboxComponentSections.Background]: {
    cssSelectorId: undefined as CssSelectorId | undefined,
    hasBackgroundImage: true,
    hasDefaultValue: false,
  },
  [ToolboxComponentSections.Border]: {
    isVisible: true,
    cssSelectorId: undefined as CssSelectorId | undefined,
  },
  [ToolboxComponentSections.Shadow]: {
    isVisible: true,
    cssSelectorId: undefined as CssSelectorId | undefined,
    isFilter: false,
  },
};

export type ToolboxComponentSchema = typeof defaultToolboxComponentSchema;

export type ToolboxComponentSchemaResolver = Partial<{
  [ToolboxComponentSections.NameAndType]: Partial<ToolboxComponentSchema['NameAndType']>;
  [ToolboxComponentSections.Generic]: Partial<ToolboxComponentSchema['Generic']>;
  [ToolboxComponentSections.Layout]: Partial<ToolboxComponentSchema['Layout']>;
  [ToolboxComponentSections.Size]: Partial<ToolboxComponentSchema['Size']>;
  [ToolboxComponentSections.Spacing]: Partial<ToolboxComponentSchema['Spacing']>;
  [ToolboxComponentSections.Background]: Partial<ToolboxComponentSchema['Background']>;
  [ToolboxComponentSections.Border]: Partial<ToolboxComponentSchema['Border']>;
  [ToolboxComponentSections.Shadow]: Partial<ToolboxComponentSchema['Shadow']>;
}>;
